import { useEffect } from 'react'

const tweakScroll = () => {
  const html = document.querySelector('html')

  if (!html) return

  html.style.overflowY = 'hidden'
}

const restoreScroll = () => {
  const html = document.querySelector('html')

  if (!html) return

  html.style.overflowY = 'auto'
}

const useScroll = () => {
  useEffect(() => {
    tweakScroll()

    return () => {
      restoreScroll()
    }
  })
}

export default useScroll
